export const mlbUrls = {
  termsOfUse:
    "https://www.mlb.com/app/ballpark/official-information/terms-of-use",
  privacyPolicy:
    "https://www.mlb.com/app/ballpark/official-information/privacy-policy",
};
